import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Comune } from 'app/main/pages/dvr/dvr-2022/interfaces';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { Costanti } from '../costanti';
import { LoaderOptions, loaderContext } from '../loader.interceptor';

@Injectable({ providedIn: 'root' })
export class CommonService {
  private BASEURL = Costanti.APIURL + 'common/';

  httpInterceptorBypass: HttpClient;

  protected loadingSubject = new BehaviorSubject(false);
  loading$ = this.loadingSubject.asObservable();

  constructor(
    private http: HttpClient,
    handler: HttpBackend
  ) {
    this.httpInterceptorBypass = new HttpClient(handler);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error); // log to console instead
      console.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

  private extractData(res) {
    return res['data'] || {};
  }

  getAppVersion(): Observable<{ versione: number }> {
    const url = this.BASEURL + 'get-version';
    const body = { piattaforma: 2 };
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'C46926949A9BF1D14527C58E02257C4AA6B089F4E7BF4AABF5DCFD3D8A9918F2');
    return this.httpInterceptorBypass
      .post(url, body, { headers, withCredentials: true })
      .pipe(map(this.extractData), catchError(this.handleError<JSON>(url)));
  }
  calcolaCodiceFiscale(dati): Observable<JSON> {
    const url = this.BASEURL + 'calcola-codice-fiscale';

    this.loadingSubject.next(true);
    const body = {
      dati
    };

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  getAssociazioni(nome?): Observable<JSON[]> {
    const url = this.BASEURL + 'associazioni';

    this.loadingSubject.next(true);
    const body = {
      nome: nome
    };

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  getComuni(nome?): Observable<Comune[]> {
    const url = this.BASEURL + 'comuni';

    this.loadingSubject.next(true);
    const body = {
      nome: nome
    };

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  getComune(id: number): Observable<Comune | null> {
    const url = this.BASEURL + 'comune';

    this.loadingSubject.next(true);
    return this.http.post(url, { id }).pipe(
      map(res => res['data'] || null),
      catchError(this.handleError<Comune | null>(url, null)),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  getProvince(nome?, options?: LoaderOptions): Observable<any> {
    const url = this.BASEURL + 'province';

    this.loadingSubject.next(true);
    const body = {
      nome: nome
    };

    return this.http.post(url, body, loaderContext(options)).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  getProvinceNazioneAsync(): Promise<JSON[]> {
    const url = this.BASEURL + 'province-nazione';

    this.loadingSubject.next(true);
    const body = {};

    return this.http
      .post(url, body)
      .pipe(
        //retry(3),
        map(this.extractData),
        catchError(this.handleError<JSON>(url)),
        finalize(() => this.loadingSubject.next(false))
      )
      .toPromise();
  }
  getProvinceNazione(): Observable<JSON[]> {
    const url = this.BASEURL + 'province-nazione';

    this.loadingSubject.next(true);
    const body = {};

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }

  getRegioni(nome?): Observable<JSON[]> {
    const url = this.BASEURL + 'regioni';

    this.loadingSubject.next(true);
    const body = {
      nome: nome
    };

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  getNazioni(nome?): Observable<JSON[]> {
    const url = this.BASEURL + 'nazioni';
    this.loadingSubject.next(true);
    return this.http.post(url, {}).pipe(
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  getProvinceRegione(id_regione?): Observable<JSON[]> {
    const url = this.BASEURL + 'province-regione';

    this.loadingSubject.next(true);
    const body = {
      id_regione: id_regione
    };

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  setDownloadDocumento(id_documento): Observable<JSON> {
    const url = this.BASEURL + 'set-download-documento';

    this.loadingSubject.next(true);
    const body = {
      id_documento: id_documento
    };

    return this.http.post(url, body).pipe(
      //retry(3),
      map(this.extractData),
      catchError(this.handleError<JSON>(url)),
      finalize(() => this.loadingSubject.next(false))
    );
  }
  stats(dati): Promise<any> {
    const url = this.BASEURL + 'system/check';

    this.loadingSubject.next(true);
    const body = {
      dati: dati
    };

    return this.http
      .post(url, body)
      .pipe(
        //retry(3),
        map(this.extractData),
        catchError(this.handleError<any>(url)),
        finalize(() => this.loadingSubject.next(false))
      )
      .toPromise();
  }
}
